module.exports = __webpack_public_path__ + "static/img/图层22.f86adbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层22.png
// module id = dpva
// module chunks = 0